import React from 'react';
import Link from 'gatsby-link';
import Markdown from 'react-markdown';
import Helmet from 'react-helmet';
import { Grid, Typography } from '@material-ui/core';
import gql from 'graphql-tag';
import styled from '../utils/styled';
import Button from '../components/Button';
import Section from '../components/Section';

const content = `
Meie ettevõte korraldab lastele-noorele sünnipäeva tähistamiseks ja ettevõtetele suvepäevade
programmiks seikluslikke matku looduses, et avastada uusi matkatarkuseid, seigelda ja pakkuda ägedat elamust!

Lisaks aitame teostda teie seikluse ideid looduses olgu see siis matk, retk või rännak jalgsi,
ratastel või kanuudel.

Korraldame ka ise matku ja sündmuseid millest on võimalik hvilistel osa võtta.

Üks on kindel - Elu on seiklust väärt!

Meie põhiteenustega saate tutvuda Teenuste sektsioonis.`;

const Home = ({ data }) => {
  return (
    <Section id="algus-section">
      <Grid item xs={12} sm={8}>
        <Helmet title="Algus" />
        <Typography variant="display1">Tere tulemast!</Typography>
        <Typography component={Markdown} source={content} align="justify"/>
        <Button component={Link} to="/services" variant="stroked">Teenused</Button>
      </Grid>
    </Section>
  );
};
export default Home;



// WEBPACK FOOTER //
// ./src/pages/index.js